import React, { Component } from 'react';
import styled from 'styled-components';

//──── Icons ─────────────────────────────────────────────────────────────────────────────
const BaseIcon = function BaseIcon(_ref) {
  const color = _ref.color,
    _ref$pushRight = _ref.pushRight,
    pushRight = _ref$pushRight === undefined ? true : _ref$pushRight,
    children = _ref.children;
  return React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: color,
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      style: { marginRight: pushRight ? '10px' : '0', minWidth: 24 }
    },
    children
  );
};

const InfoIcon = () => React.createElement(
  BaseIcon,
  { color: '#2E9AFE' },
  React.createElement('circle', { cx: '12', cy: '12', r: '10' }),
  React.createElement('line', { x1: '12', y1: '16', x2: '12', y2: '12' }),
  React.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '8' })
);

const SuccessIcon = () => React.createElement(
  BaseIcon,
  { color: '#31B404' },
  React.createElement('path', { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }),
  React.createElement('polyline', { points: '22 4 12 14.01 9 11.01' })
);

const ErrorIcon = () => React.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24', style: { marginRight: '10px', minWidth: 24 } },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', { d: 'M0 0h24v24H0z' }),
    // eslint-disable-next-line max-len
    React.createElement('path', { fill: '#E34D57', fillRule: 'nonzero', d: 'M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm-1-4h2v-3h-2v3zm0-5h2V6h-2v7z' })
  )
);

const CloseIcon = () => React.createElement(
  BaseIcon,
  { color: '#FFFFFF', pushRight: false },
  React.createElement('line', { x1: '18', y1: '6', x2: '6', y2: '18' }),
  React.createElement('line', { x1: '6', y1: '6', x2: '18', y2: '18' })
);

//──── Styles ────────────────────────────────────────────────────────────────────────────
const AlertStyleDiv = styled.div`
  background-color: #3a3d4d;
  color: white;
  padding: 0 10px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.03);
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
`;

const Button = styled.button`
  margin-left: 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: #FFFFFF;
`;


class AlertTemplate extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { message, handleClose, condition, styles, id, classNames } = this.props;

    return (
      <AlertStyleDiv className={classNames} id={id} style={styles}>
        {condition === 'error' && <ErrorIcon />}
        {condition === 'success' && <SuccessIcon />}
        <span style={{ flex: 2, padding: '15px 0' }}>{message}</span>
        {/* <Button onClick={handleClose}>
          <CloseIcon></CloseIcon>
        </Button> */}
      </AlertStyleDiv>
    );
  }
}

export default AlertTemplate;